import React from 'react';
import { AppBar, Box, Drawer, Grid, IconButton, Paper, Toolbar, Typography } from '@mui/material';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Dashboard, Settings, BarChart, RestaurantMenu, AccountBalance, TableChart } from '@mui/icons-material';
import { AppBarHome } from './AppBar';

const DashboardPage: React.FC = () => {
  return (
    <AppBarHome/>
  );
};

export default DashboardPage;
